import React from 'react';
import isEqual from 'lodash/isEqual';
import Alert from '../../components/Alert';
import PaymentOptions from '../components/PaymentOptions';
import Price from '../components/Price';
import ProductWidgetPage from '../ProductWidgetPage';
import CloseModalIcon from '../components/CloseModalIcon';
import UpdatedBookingPage from '../components/UpdatedBookingPage';
import Translation from '../../utilities/localizationUtility';
import { stringToBoolean } from '../../utilities/conversionUtility';
import ConfirmationPage from '../components/CourseConfirmationPage';
import BrandingString from '../components/BrandingString';
import { StyledTimeZone, StyledTermSelect } from './CoursePage.style';

export default class CoursePage extends ProductWidgetPage {
  constructor(props) {
    super(props);

    this.state = {
      termOptions: [],
      modalHeight: 100,
      isModalOpen: false,
      messages: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(oldProps) {
    const { exceededBookingsLimit, exceededTrialPlan, selectedLocation, onLoadFrames } = this.props;
    const { selectedLocation: prevSelectedLocation } = oldProps;
    const currentSelectedLocation = prevSelectedLocation || {};
    const nextSelectedLocation = selectedLocation || {};

    if (!isEqual(nextSelectedLocation, currentSelectedLocation) && !exceededBookingsLimit && !exceededTrialPlan) {
      if (onLoadFrames) {
        onLoadFrames(nextSelectedLocation);
      }
    }
  }

  buildReschedulePayload(item) {
    const { order } = this.props;
    return { booking: { start: item.start, finish: item.finish, term: order.termSelected?.name } };
  }

  getCanBook() {
    const { termOptions } = this.state;
    const {
      order: { termSelected, variantSelected },
    } = this.props;

    let option;
    let canBook = false;

    if (termOptions.length && !!variantSelected) {
      option = termOptions.find((o) => o.id === termSelected.id);
      canBook = option && !option.disabled;
    }

    return canBook;
  }

  getSubmitButtonLabel() {
    const { bookingToken } = this.props;
    const t = new Translation(this.props);
    return bookingToken ? t.key('reschedule') || 'Reschedule' : null;
  }

  handleAddItems(reservation, callback) {
    const type = ['Start', 'Finish', 'Location', 'Term'];

    this.onAddItems({
      reservation,
      type,
      callback,
    });
  }

  handleSubmit(e) {
    const { order, orderActions: { submitCourseOrder }, bookingFields } = this.props;
    const items = [{ external_id: order.variantSelected, quantity: order.quantity }];
    const messages = [];
    this.checkValidLocation(messages);

    this.onSubmit({
      element: e,
      messages,
      itemsResponse: items,
      action: submitCourseOrder,
      bookingFields,
    });
  }

  getNextButtonLabel(canBook) {
    const t = new Translation(this.props);
    return canBook ? t.key('nextButton') : t.key('noAvailability');
  }

  render() {
    const { bookingUpdated } = this.state;
    if (bookingUpdated) return <UpdatedBookingPage />;

    const {
      frames: { loading },
      locale,
      order,
      orderActions,
      productTitle,
      setting,
      shopDateFormat,
      style,
      timeInterval,
      timeZone,
      brandingVisualized,
    } = this.props;
    const { modalHeight, termOptions } = this.state;
    const canBook = this.getCanBook();
    const t = new Translation(this.props);
    const showBookingFields = stringToBoolean(setting.show_booking_fields);
    const selectedTermOption = termOptions.find((x) => x.id === order?.termSelected.id);
    const isRenderWaitlistButton = !loading && this.showWaitlist() && order.termSelected
      && order.termSelected.start_date && !canBook;
    const selectedTime = order && order.termSelected ? order.termSelected.start_date : null;

    return (
      <div className="center widget-container" style={{ minHeight: modalHeight + 20 }}>
        <CloseModalIcon />
        <Alert ref={this.setAlertRef} />
        <div className={`sub-panel ${setting.mode}`} style={{ ...style.body, ...style.boxShadow }}>
          <h3 className="text-center widget-title" style={{ ...style.title }}>
            {t.key('title')}
          </h3>

          {this.renderExceededAlert()}
          {this.renderLocationDropdown(loading)}
          {this.renderResourceDropdawn()}
          {this.renderVariantSelect()}
          {this.renderQuantityInput(selectedTermOption?.maxAvailability || 1)}

          <PaymentOptions />

          <StyledTermSelect
            style={style.body}
            termOptions={termOptions}
            onOptionsChange={(options) => this.setState({ termOptions: options })}
          />
          <StyledTimeZone timeZone={timeZone} />
          <Price title={`${t.key('price')}`} />
          {this.renderWaitlist(selectedTime)}
          {isRenderWaitlistButton ? this.renderWaitlistButton() : this.renderButton(canBook, loading)}

          {this.renderModal(
            <ConfirmationPage
              canBook={canBook}
              closeModal={this.closeModal ? this.closeModal : () => {}}
              dateFormat={shopDateFormat}
              enabledBookingFields={showBookingFields}
              getValidationFn={this.handleGetValidationFn}
              locale={locale}
              orderActions={orderActions}
              productTitle={productTitle}
              renderSubmitButton={this.renderSubmitButton}
              setting={setting}
              setWrapperHeight={this.setWrapperHeight}
              style={style}
              timeInterval={timeInterval}
              termSelected={order.termSelected}
              timeZone={timeZone}
              translation={t}
              variants={order.variants}
            />,
            brandingVisualized
          )}
          {brandingVisualized && <BrandingString />}
        </div>
      </div>
    );
  }
}

CoursePage.propTypes = {};
